import { Component, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Response_CCP } from 'src/app/Interfaces/Interfaces-Global/Response.interface';
import { Headers_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Headers-CCP.interface';
import { RoleCCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Role/CreateRoleCCP.interface';
import { LIBRARYCCPService } from 'src/app/Services/Libraries/General-CCP/library-ccp.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-see-all-gene-role-ccp',
    templateUrl: './see-all-gene-role-ccp.component.html',
    styleUrls: ['./see-all-gene-role-ccp.component.scss', '../../../../../Styles/GlobalStyles.css', '../../../../../Styles/SharedFolder.scss', '../../../../../Styles/RoleGlobal.scss'],
    standalone: false
})
export class SeeAllGeneRoleCCPComponent {


  //-========================= SECTION VARIABLES =========================-\\

  //+================== FILTER ==================+\\
  public Role_Filter: string = '';


  //+================== VARIABLES FOR PAGINATION ==================+\\
  public first: number = 0;
  public rows: number = 10;

  public first_GA: number = 0;
  public rows_GA: number = 10;


  //+================== VARIABLES FOR HEADERS TASK ==================+\\
  public Headers_Shared: Headers_CCP[] = [
    { ID: 1, Name: 'Nombre', Position: 1, Visible: true, Key_Header: 'NAM' },
    { ID: 1, Name: 'Descripción', Position: 1, Visible: true, Key_Header: 'DES' },
    { ID: 1, Name: '', Position: 1, Visible: true, Key_Header: 'DEL' },
  ];

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';




  //+================== VARIABLES FOR ROLE ==================+\\
  public Roles: RoleCCP[] = [];
  public Selected_Roles: RoleCCP[] = [];



  //+================== VARIABLES FOR LOAD PAGE ==================+\\
  public LoadPage: boolean = false;





  //-========================= SERVICES =========================-\\
  private Service_CCP = inject(LIBRARYCCPService);


  ngOnInit(): void {
    this.Load_Component();
  }



  //&===================== FUNCTIONS FOR LOAD COMPONENT =====================&\\

  //-================== FUNCTTION FOR LOAD COMPONENT ==================-\\
  private async Load_Component(): Promise<void> {

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    this.LoadPage = false;
    try {

      await this.Load_Roles();

      Loader.classList.remove('active');
      this.LoadPage = true;
    } catch (e) {

      Swal.fire({
        title: 'Ocurrió un error',
        text: '¡Notifique este error al supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });

      Loader.classList.remove('active');

    }

  }

  //-================== FUNCTTION FOR LOAD ROLE WHIT RELATION A FOLDER ==================-\\
  private async Load_Roles(): Promise<boolean> {

    try {

      const ResGetRoles: Response_CCP = await firstValueFrom(this.Service_CCP.Get_All_Role_CCP());


      if (ResGetRoles.success) {
        this.Roles = ResGetRoles.operation;

      }
      return true;

    } catch (e) {

      Swal.fire({
        title: 'Ocurrió un error (Roles)',
        text: '¡Notifique este error al supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });

      return false;
    }
  }





  //&===================== END FUNCTIONS FOR LOAD COMPONENT =====================&\\




  //&===================== FUNCTIONS FOR OPTIONS IN CARDS =====================&\\


  //-================== FUNCTTION FOR RELOAD PAGE ==================-\\
  public Reload_Page(): void {
    this.Load_Component();
  }

  //&===================== END FUNCTIONS FOR OPTIONS IN CARDS =====================&\\



  //&===================== FUNCTIONS FOR DELETE ROLE =====================&\\

  //-================== FUNCTTION FOR DELETE ROLE ==================-\\
  public Delete_Role(Role: RoleCCP): void {

    const NameDelete: string = Role.Name.trim()


    Swal.fire({
      title: '¿Está seguro de eliminar rol de Processes?',
      text: "¡No podrá revertir cambios!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '¡sí, eliminar!'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Nuevamente ¿está seguro?',
          text: `¡Para eliminar el rol escriba '${NameDelete}' !`,
          input: 'text',
          confirmButtonText: 'Continuar <i class="fa-solid fa-right-long"></i>',
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          showCancelButton: true,
        }).then((async result2 => {

          if (result2.isConfirmed) {

            const ValueInput: string = result2.value;

            if (ValueInput.toLowerCase() === NameDelete.toLowerCase()) {


              try {

                const Res_Delete_Role: Response_CCP = await firstValueFrom(this.Service_CCP.Delete_Role_CCP({ ID_Role: Role.ID }))

                if (Res_Delete_Role.success) {
                  Swal.fire({
                    icon: 'success',
                    title: 'Rol eliminado',
                    text: '¡Se eliminó correctamente el rol!',
                    confirmButtonColor: this.ColorConfirm
                  })
                  this.Load_Component();
                } else {
                  throw Res_Delete_Role.message;
                }


              } catch (error) {
                Swal.fire({
                  title: 'Ocurrió un error',
                  text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
                  icon: 'warning',
                  confirmButtonColor: this.ColorConfirm
                })
                this.Load_Component();
              }

            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Sin coincidencia',
                text: '¡Escriba correctamente el nombre del grupo para eliminarlo!',
                confirmButtonColor: this.ColorConfirm
              })
            }
          }
        }))
      }
    })
  }

  //&===================== END FUNCTIONS FOR DELETE ROLE =====================&\\


}
